import React, { Component } from 'react';
import ItemImage from './ItemImage';
import {
  parsePrice,
  getNutritionHeader,
  isAvailableNow,
} from '../../../../lib/helper.js';
import { OUT_OF_STOCK } from '../../../../util/Constants';
import NutritionalIcon from './components/NutritionalIcon';
import { get, isEmpty } from 'lodash';
import { Media } from 'react-bootstrap';
import Description from './components/Description';
import { connect } from 'react-redux';

class Front extends Component {
  switchModal() {
    let itemCopy = Object.assign({}, this.props.item);
    this.props.switchModal(itemCopy);
  }
  flip() {
    this.props.flip();
  }

  openNutritionInfo() {
    this.props.openNutritionInfo();
  }

  isNutritionSet(nutrition) {
    return nutrition && nutrition[0];
  }
  componentDidMount() {
    this.scheduleUpdate();
  }
  componentDidUpdate() {
    this.scheduleUpdate();
  }
  componentWillUnmount() {
    this.schedule && clearTimeout(this.schedule);
  }
  scheduleUpdate = () => {
    const unavailableUntil = this.getUnavailableUntil();
    const currentTime = new Date().getTime();
    const diff = unavailableUntil - currentTime;
    if (diff > 0) {
      this.schedule && clearTimeout(this.schedule);
      this.schedule = setTimeout(() => {
        this.forceUpdate();
      }, diff + 1);
    }
  };
  getUnavailableUntil = () => {
    const { unavailableUntil } = this.props;
    return unavailableUntil === undefined
      ? +get(this.props, 'item.unavailable_until', 0)
      : unavailableUntil;
  };
  render() {
    const description = get(this, 'props.item.description', '');
    const nutritionList = this.props.item.nutrition;
    const unavailableUntil = this.getUnavailableUntil();
    const isAvailable = isAvailableNow(unavailableUntil);
    const outOfStock =
      unavailableUntil === undefined
        ? get(this, 'props.item.availability', '').toLowerCase() ===
            OUT_OF_STOCK || !isAvailable
        : !isAvailable;
    return (
      <div className={`${outOfStock ? 'outOfStock' : ''} front`}>
        <div className="panel panel-default">
          <div
            className="panel-body panel-card"
            onClick={!outOfStock ? () => this.switchModal() : null}
          >
            <Media>
              <Media.Body>
                <h5 className="media-heading itemName ">
                  {this.props.item.name}
                </h5>

                <div className="nutrition-information">
                  <span className="panel-short-nutrition">
                    {!isEmpty(nutritionList)
                      ? getNutritionHeader(nutritionList)
                      : null}
                  </span>
                  <NutritionalIcon
                    status={this.props.item.heart_healthy}
                    type="heart"
                  />
                  <NutritionalIcon
                    status={this.props.item.contains_gluten}
                    type="gluten"
                  />
                  <NutritionalIcon
                    status={this.props.item.contains_dairy}
                    type="dairy"
                  />
                </div>

                <Description text={description} />

                <div className="price-details">
                  <span className="itemPrice">
                    {parsePrice(this.props.item.price)}
                  </span>
                </div>
              </Media.Body>
              <Media.Right>
                <ItemImage
                  switchModal={() => this.switchModal()}
                  imageLink={
                    this.props.item.images
                      ? this.props.item.images.thumbnail
                      : ''
                  }
                  imageName={this.props.item.name}
                  imagePresent={this.props.item.item_image_present}
                  outOfStock={outOfStock}
                />
              </Media.Right>
            </Media>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const menu_items = get(state, 'rtd.status.menu_item', {});
  const unavailableUntil = menu_items[ownProps.item.id];
  return { unavailableUntil };
};

export default connect(mapStateToProps)(Front);



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/Front.jsx